import {defineStore} from 'pinia'
import {useApiRequestStore} from '../../ApiRequestStore/useApiRequestStore'

import {
  IGetJobRequestInterfaces,
} from '@toolify/server/src/controllers/JobController/validators/GetJob/types/IGetJobRequestInterfaces.js'
import {mapJobResponseInstance} from '@toolify/client/src/modules/api/singletons/mapJobResponseInstance.js'

export const useJobApiStore = defineStore('jobApi', {
  actions: {
    async getJob(jobId: string): Promise<IGetJobRequestInterfaces['response']> {
      const apiRequestStore = useApiRequestStore()
      const res = await apiRequestStore.get<IGetJobRequestInterfaces>(`/job/${jobId}`)
      return {
        job: mapJobResponseInstance(res.job),
      }
    },
  },
})
